module.exports = __webpack_public_path__ + "static/media/logo_omm.dd2991a0.png";